import { render, staticRenderFns } from "./ProjectCommentsMobileMenu.vue?vue&type=template&id=07f8e364&"
import script from "./ProjectCommentsMobileMenu.vue?vue&type=script&lang=js&"
export * from "./ProjectCommentsMobileMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports